import themeJson from "./smylor/smylor.json";
import extended from './smylor/extended.json';

export const getTheme = () => {
  const theme: { [key: string]: any } = {};
  const variables: any = themeJson.groups[0].variables;
  const themeVariables: any = {...variables, ...extended };

  Object.keys(themeVariables).map((keyval: string) => {
    theme[keyval] = themeVariables[keyval].value;
  });
  return theme;
};  
